const da = {
  // ── Navigation ──────────────────────────────────────────
  dashboard:'داشبورد',
  invoicesTab: 'فاکتور',
  sales:'فروشات',
  purchases:'خریدها',
  inventory:'موجودی',
  accounting:'حسابداری',
  finance:'امور مالی',
  management:'مدیریت',
  reports:'گزارشات',
  invoices:'فاکتورها',
  customers:'مشتریان',
  suppliers:'سپلایرها',
  products:'محصولات',
  partners:'شرکا',
  expenses:'مصارف',
  revenues:'درآمدها',
  cashbox:'صندوق',
  bank:'بانک',
  budget:'بودجه',
  assets:'دارایی ثابت',
  users:'کاربران',
  branches:'شعبات',
  settings:'تنظیمات',
  audit:'گزارش تغییرات',
  journals:'دفتر روزنامه',
  accounts:'پلان حسابات',
  trialBalance:'تراز آزمایشی',
  incomeStatement:'سود و زیان',
  balanceSheet:'ترازنامه',
  customerBalanceList:'بیلانس مشتریان',
  debitBalance:'بدهکار',
  creditBalance:'بستانکار',
  newSale:'فروش جدید',
  salesList:'لیست فروشات',
  purchasesList:'لیست خریدها',
  productsList:'لیست محصولات',
  inventoryReport:'گزارش موجودی',
  cashflow:'جریان نقدی',
  ledger:'دفتر کل',
  fiscalYears:'سال‌های مالی',

  // ── Common Actions ───────────────────────────────────────
  save:'ذخیره',
  cancel:'انصراف',
  edit:'ویرایش',
  delete:'حذف',
  add:'اضافه کردن',
  search:'جستجو',
  filter:'فیلتر',
  print:'چاپ',
  export:'خروجی',
  close:'بستن',
  confirm:'تایید',
  approve:'تایید کردن',
  reject:'رد کردن',
  back:'برگشت',
  view:'مشاهده',
  create:'ایجاد',
  update:'به‌روزرسانی',
  remove:'حذف',
  loading:'در حال بارگذاری...',
  noData:'داده‌ای یافت نشد',
  total:'مجموع',
  yes:'بله',
  no:'خیر',
  required:'الزامی',
  optional:'اختیاری',
  success:'عملیات موفق',
  error:'خطا',
  warning:'هشدار',
  info:'اطلاعات',
  addSuccess:'با موفقیت اضافه شد',
  updateSuccess:'با موفقیت به‌روزرسانی شد',
  deleteSuccess:'با موفقیت حذف شد',

  // ── Status ───────────────────────────────────────────────
  active:'فعال',
  inactive:'غیرفعال',
  draft:'پیش‌نویس',
  approved:'تایید شده',
  pending:'در انتظار',
  cancelled:'لغو شده',
  paid:'پرداخت شده',
  unpaid:'پرداخت نشده',
  partial:'جزئی',
  overdue:'معوق',
  confirmed:'تایید شده',

  // ── Common Fields ────────────────────────────────────────
  date:'تاریخ',
  name:'نام',
  type:'نوع',
  status:'وضعیت',
  amount:'مبلغ',
  currency:'ارز',
  description:'شرح',
  notes:'یادداشت',
  code:'کود',
  actions:'عملیات',
  phone:'تلفن',
  email:'ایمیل',
  address:'آدرس',
  number:'شماره',
  reference:'مرجع',
  quantity:'تعداد',
  unit:'واحد',
  price:'قیمت',
  discount:'تخفیف',
  tax:'مالیات',
  subtotal:'جمع کالا',
  remaining:'باقیمانده',
  debit:'بدهکار',
  credit:'بستانکار',
  balance:'مانده',
  branch:'شعبه',
  company:'شرکت',
  createdAt:'تاریخ ثبت',
  updatedAt:'تاریخ به‌روزرسانی',
  createdBy:'ثبت کننده',

  // ── Sales ────────────────────────────────────────────────
  saleNumber:'شماره فروش',
  payCustomerDebt: 'پرداخت قرض',
  paymentForInvoice: 'پرداخت شده',
  customer:'مشتری',
  customerName:'نام مشتری',
  customerPhone:'تلفن مشتری',
  cheque: 'چک',
  saleType:'نوع فروش',
  cash:'نقدی',
  credit:'نسیه',
  addPayment:'ثبت پرداخت',
  payRemaining:'پرداخت باقیمانده',
  paymentHistory:'تاریخچه پرداخت',
  paymentMethod:'روش پرداخت',
  paymentAmount:'مبلغ پرداخت',
  payFull:'پرداخت کامل',
  payHalf:'نصف مبلغ',
  invoiceItems:'اقلام فاکتور',
  scanBarcode:'اسکن بارکد',
  selectCustomer:'انتخاب مشتری',
  cart:'سبد خرید',
  clearCart:'پاک کردن',
  registerSale:'ثبت فاکتور فروش',
  noStock:'موجودی ندارد',
  insufficientStock:'موجودی کافی نیست',
  invoiceTypes: 'نوع فروش',
  searchInvoice: 'جستجوی فاکتور',
  totalInvoices: 'مجموع فاکتورها',
  filterInvoices: 'فیلتر فاکتور',
  newCustomer: 'مشتری جدید',
  newSupplier: 'تآمین کننده جدید',
  lowStockOnly: 'موجودی کم',
  newPartner: 'شریک جدید',
  list: 'لیست',
  reportType: 'نوع گزارش',
  transactions: 'تراکنش ها',
  selectCategory: 'انتخاب دسته بندی',

  // ── Purchases ────────────────────────────────────────────
  purchaseNumber:'شماره خرید',
  supplier:'سپلایر',
  supplierName:'نام سپلایر',
  searchSupplier:'جستجوی سپلایر...',
  searchProduct:'جستجوی محصول...',
  newPurchase:'خرید جدید',
  purchaseItems:'اقلام خرید',
  prepayment:'پیش‌پرداخت',

  // ── Products ─────────────────────────────────────────────
  productName:'نام محصول',
  productCode:'کود محصول',
  category:'دسته‌بندی',
  buyPrice:'قیمت خرید',
  sellPrice:'قیمت فروش',
  setLotSellPrice:'تعیین قیمت فروش این محموله',
  lotSellPriceNote:'قیمت فروش هر محموله جدا از محموله‌های قبلی همین کالا ذخیره می‌شود.',
  currentStock:'موجودی فعلی',
  minStock:'حداقل موجودی',
  barcode:'بارکد',
  brand:'برند',
  newProduct:'محصول جدید',
  stockValue:'ارزش موجودی',
  lowStockAlert:'هشدار کمبود',

  // ── Customers ────────────────────────────────────────────
  customerProfile:'پروفایل مشتری',
  customerDebt:'بدهی مشتری',
  payDebt:'پرداخت بدهی',
  totalPurchases:'مجموع خریدها',
  totalSales:'مجموع فروش',
  accountBalance:'مانده حساب (خالص)',
  customerOwesUs:'مشتری به ما بدهکار است',
  weOweCustomer:'ما به مشتری بدهکاریم',
  salesRemaining:'باقی فروش (دریافتنی)',
  purchasesRemaining:'باقی خرید (پرداختنی)',
  totalPayments:'مجموع پرداخت‌ها',
  lastTransaction:'آخرین تراکنش',
  accountStatement:'کارت حساب',
  purchasedProducts:'محصولات خریداری',
  fifoPayment:'پرداخت FIFO',
  generalInfo: 'معلومات مشتری',
  paymentsTab: 'پرداخت ها',
  paymentDate: 'تاریخ پرداخت',
  invoice: 'فاکتور',
  method: 'روش',
  productsTab: 'محصولات',
  statementTab: 'وضعیت',
  totalAmount: 'مجموع',
  lastPurchase: 'آخرین پرداخت',


  // ── Suppliers ────────────────────────────────────────────
  supplierProfile:'پروفایل سپلایر',
  supplierDebt:'بدهی سپلایر',
  paySupplier:'پرداخت به سپلایر',
  purchaseHistory:'تاریخچه خرید',

  // ── Accounting ───────────────────────────────────────────
  chartOfAccounts:'پلان حسابات',
  journalEntries:'دفتر روزنامه',
  accountCode:'کود حساب',
  accountName:'نام حساب',
  accountType:'نوع حساب',
  asset:'دارایی',
  liability:'بدهی',
  equity:'سرمایه',
  liabilities:'بدهی‌ها',
  cashOnHand:'موجودی نقد صندوق‌ها',
  autoAccountsNote:'دفتر حساب‌ها به‌صورت خودکار ساخته و نگهداری می‌شود',
  autoJournalNote:'همه اسناد به‌صورت خودکار از فروش، خرید، هزینه، درآمد و تراکنش‌های صندوق ثبت می‌شوند',
  revenue:'درآمد',
  expense:'هزینه',
  group:'گروه اصلی',
  general:'حساب کل',
  subsidiary:'حساب معین',
  normalBalance:'مانده طبیعی',
  parentAccount:'حساب مادر',
  journalNumber:'شماره سند',
  entry:'ثبت',
  lines:'ردیف‌ها',
  balanced:'متوازن',
  unbalanced:'نامتوازن',
  addLine:'ردیف جدید',
  saleUnitsConfig:'واحدهای فروش دیگر (با ضریب تبدیل)',
  saleUnitsConfigNote:'مثال: کارتن = ۱۰ عدد — یعنی فروش ۱ کارتن، ۱۰ عدد از موجودی کم می‌کند.',
  noUnitsAdded:'واحد دیگری اضافه نشده',
  unitName:'نام واحد (مثلاً کارتن)',
  conversionFactor:'ضریب',
  selectUnit:'انتخاب واحد',

  // ── Finance ──────────────────────────────────────────────
  transaction:'تراکنش',
  receipt:'دریافت',
  payment:'پرداخت',
  transfer:'انتقال',
  cashBalance:'موجودی صندوق',
  bankBalance:'موجودی بانک',
  totalIncome:'مجموع دریافت',
  totalOutcome:'مجموع پرداخت',

  // ── Reports ──────────────────────────────────────────────
  salesReport:'گزارش فروشات',
  purchasesReport:'گزارش خریدها',
  customersReport:'گزارش مشتریان',
  suppliersReport:'گزارش سپلایرها',
  inventoryRep:'گزارش موجودی',
  expensesReport:'گزارش مصارف',
  cashboxReport:'گزارش صندوق',
  incomeReport:'گزارش سود و زیان',
  topCustomers:'برترین مشتریان',
  dailyChart:'نمودار روزانه',
  period:'دوره',
  today:'امروز',
  thisWeek:'این هفته',
  thisWeekShort:'هفته',
  thisMonth:'این ماه',
  thisQuarter:'سه ماهه',
  thisYear:'این سال',
  custom:'دلخواه',
  startDate:'از تاریخ',
  endDate:'تا تاریخ',
  refresh:'بروزرسانی',
  grossProfit:'سود ناخالص',
  netProfit:'سود خالص',
  totalExpenses:'مجموع مصارف',
  totalRevenue:'مجموع درآمد',
  operatingProfit:'سود عملیاتی',

  // ── Partners ─────────────────────────────────────────────
  partner:'شریک',
  partnerCode:'کود شریک',
  partnerName:'نام شریک',
  partnerType:'نوع شریک',
  individual:'حقیقی',
  joinDate:'تاریخ عضویت',
  sharePercent:'درصد سهم',
  capital:'سرمایه',
  initialCapital:'سرمایه اولیه',
  currentCapital:'سرمایه جاری',
  addCapital:'افزایش سرمایه',
  reduceCapital:'کاهش سرمایه',
  transferCapital:'انتقال سرمایه',
  withdraw:'برداشت',
  invest:'سرمایه‌گذاری',
  profitShare:'تقسیم سود',
  totalPartners:'تعداد شرکا',
  totalCapital:'مجموع سرمایه',
  undistributedProfit:'سود توزیع نشده',
  monthWithdrawals:'برداشت ماه',
  monthDeposits:'واریز ماه',
  capitalAccount:'حساب سرمایه',
  currentAccount:'حساب جاری',
  profitAccount:'حساب سود',
  withdrawalAccount:'حساب برداشت',
  partnerReport:'گزارش شرکا',
  capitalReport:'گزارش سرمایه',
  transactionHistory:'تاریخچه تراکنش‌ها',
  distributeProfit:'توزیع سود',
  shareAmount:'مبلغ سهم',

  // ── Dashboard ────────────────────────────────────────────
  todaySales:'فروش امروز',
  monthSales:'فروش ماه',
  lowStock:'کمبود موجودی',
  outOfStock:'ناموجود',
  totalCustomers:'مجموع مشتریان',
  todayInvoices:'فاکتور امروز',
  receivable:'بدهکاران',
  payable:'بستانکاران',
  recentSales:'آخرین فروشات',
  recentExpenses:'آخرین مصارف',
  stockWarning:'هشدار موجودی',
  monthlySales:'فروش ماهانه',

  // ── Exchange Rate ────────────────────────────────────────
  exchangeRate:'نرخ ارز',
  liveRate:'نرخ زنده',
  lastUpdated:'آخرین بروزرسانی',
  rateUnavailable:'نرخ در دسترس نیست',
  manualRate:'نرخ دستی',
  updateRate:'بروزرسانی نرخ',
  afn:'AFN',
  usd:'دالر',

  // ── Validation Messages ──────────────────────────────────
  fieldRequired:'این فیلد الزامی است',
  invalidEmail:'ایمیل معتبر نیست',
  minLength:'حداقل {n} کاراکتر',
  maxLength:'حداکثر {n} کاراکتر',
  mustBeNumber:'باید عدد باشد',
  mustBePositive:'باید بیشتر از صفر باشد',
  deleteReason:'دلیل حذف الزامی است',
  balanceRequired:'تراز بدهکار و بستانکار باید برابر باشد',
  shareExceeds:'مجموع سهم‌ها از 100% تجاوز می‌کند',

  // ── Placeholders ─────────────────────────────────────────
  phName:'نام را وارد کنید...',
  phPhone:'مثال: 0799123456',
  phEmail:'example@email.com',
  phAddress:'آدرس کامل...',
  phAmount:'مثال: 50000',
  phDescription:'شرح را بنویسید...',
  phSearch:'جستجو...',
  phCode:'کود خودکار',
  phNotes:'یادداشت اضافی...',
  phBuyPrice:'قیمت خرید...',
  phSellPrice:'قیمت فروش...',
  phStock:'تعداد موجودی...',
  phBarcode:'بارکد محصول (اختیاری)',
  phDiscount:'0',
  phReference:'شماره مرجع...',

  // ── Extended v2 ──────────────────────────────────────────
  saving:'در حال ذخیره...',
  registering:'در حال ثبت...',
  loading2:'در حال بارگذاری...',
  noParentAccount:'بدون حساب مادر',
  parentAccount2:'حساب مادر',
  optional2:'(اختیاری)',
  allItems:'همه',
  last6Months:'۶ ماه اخیر',
  selectBranch:'لطفاً از منوی بالا یک شعبه انتخاب کنید',
  branchRequired:'شعبه انتخاب نشده',
  settled2:'تسویه شده',
  settled:'تسویه شده',
  overdue2:'معوق',
  noDataChart:'داده‌ای برای نمایش ندارد',
  totalBankBalance:'مجموع موجودی بانک‌ها',
  bankTransfer:'انتقال بین حساب‌ها',
  registerTransfer:'ثبت انتقال',
  newBankAccount:'حساب جدید',
  cashboxBalance:'مانده صندوق',
  cashboxAccount:'صندوق',
  createCashbox:'ایجاد صندوق',
  editCashbox:'ویرایش صندوق',
  cashboxName:'نام صندوق',
  phCashboxName:'مثلاً صندوق نقدی، حساب بانکی...',
  initialDeposit:'واریز اولیه',
  noCashboxYet:'هنوز هیچ صندوقی ایجاد نشده',
  openingBalance:'سرمایه اولیه',
  capital:'سرمایه',
  source:'منشأ',
  automatic:'خودکار',
  manual:'دستی',
  addCapital:'افزودن سرمایه',
  addCapitalNote:'این فرم فقط برای ثبت سرمایه اولیه یا افزایش سرمایه صندوق است. تراکنش‌های فروش، خرید، هزینه و درآمد به‌صورت خودکار ثبت می‌شوند.',
  autoCashboxNote:'فروش، خرید، هزینه و درآمد به‌صورت خودکار ثبت می‌شوند',
  totalReceipt:'مجموع دریافت',
  totalPayment:'مجموع پرداخت',
  transactionType:'نوع تراکنش *',
  reportCenter:'مرکز گزارش‌ها',
  timePeriod:'دوره زمانی',
  incomeChart:'+ درآمدها',
  expensesChart:'- مصارف',
  dailyPurchasesChart:'نمودار خریدهای روزانه',
  byCategory:'مصارف بر اساس دسته',
  stockByCategory:'ارزش موجودی بر اساس دسته‌بندی',
  incomeStatement2:'صورت سود و زیان',
  compareChart:'نمودار مقایسه',
  topCustomers2:'برترین مشتریان',
  selectAccount:'انتخاب حساب...',
  journalLines:'ردیف‌های سند',
  accountingSettings:'تنظیمات حسابداری',
  todayRate:'نرخ ارز امروز',
  initialStock:'موجودی اولیه',
  autoCode:'کد محصول (خودکار)',
  minStockAlert:'حداقل موجودی (هشدار)',
  stockValuePage:'ارزش موجودی (صفحه جاری)',
  buyPriceLabel:'قیمت خرید *',
  sellPriceLabel:'قیمت فروش *',
  financialSummary:'خلاصه مالی',
  documentInfo:'اطلاعات سند',
  quickSelect:'انتخاب سریع:',
  invoiceFooter:'این فاکتور توسط سیستم حسابداری تولید شده است',
  newFiscalYear:'سال مالی جدید',
  locked:'قفل',
  closedStatus:'بسته',
  selectPartner:'انتخاب شریک...',
  lastTransactions:'آخرین تراکنش‌ها',
  noTransactionYet:'تراکنشی ثبت نشده',
  noInvoiceYet:'فاکتوری ثبت نشده',
  noProductYet:'محصولی خریداری نشده',
  noPurchaseYet:'خریدی ثبت نشده',
  noPaymentYet:'پرداختی ثبت نشده',
  overdueInvoices:'فاکتورهای معوق (از قدیم به جدید):',
  overdueCount:'تعداد فاکتور معوق',
  fifoMsg:'پرداخت از قدیمی‌ترین شروع می‌شود (FIFO)',
  overduePurchases:'خریدهای معوق (از قدیم به جدید):',
  overduePurchasesCount:'خریدهای معوق',
  exceedsDebt:'⚠ بیشتر از مجموع بدهی',
  incomeSectionTitle:'درآمدها',
  expensesSectionTitle:'مصارف',
  profitMargin:'حاشیه سود',
  reportPeriod:'دوره گزارش',
  noIncomeYet:'درآمدی ثبت نشده',
  noExpenseYet:'مصرفی ثبت نشده',
  expensesBreakdown:'تفکیک مصارف',
  mainInfo:'اطلاعات اصلی',
  priceInfo:'اطلاعات قیمت و موجودی',
  stockMovement:'گردش موجودی',
  noStockMovement:'گردش موجودی ثبت نشده',
  deleteConfirm:'تایید حذف',
  newTransaction: 'تراکنش جدید',
  income: 'در آمد',
  noTransactions: 'تراکنشی نیست',
  expenseManagement: 'مدیریت مصارفات',
  newExpense: 'مصرف جدید',
  allCategories: 'دسته بندی ها',
  monthExpenses: 'مصارف ماهانه',


  // ── Additional for Pages ─────────────────────────────────
  chartOfAccounts:'پلان حسابات',
  accounts:'حساب‌ها',
  accountLevel:'سطح حساب',
  resource:'منبع',
  id:'شناسه',
  ipAddress:'آی‌پی',
  loginLogout:'ورود/خروج',
  companyInfo:'اطلاعات شرکت',
  registrationNo:'شماره ثبت',
  taxId:'شناسه مالیاتی',
  website:'وبسایت',
  baseCurrency:'ارز پایه',
  secondCurrency:'ارز دوم',
  invoicePrefix:'پیشوند فاکتور',
  journalPrefix:'پیشوند سند',
  autoJournal:'ثبت سند اتوماتیک',
  requireApproval:'نیاز به تایید سند',
  dateFormat:'فرمت تاریخ',
  jalali:'شمسی',
  gregorian:'میلادی',
  bankManagement:'مدیریت حساب‌های بانکی',
  bankName:'نام بانک',
  accountNumber:'شماره حساب',
  ibanNumber:'شماره شبا',
  fromAccount:'از حساب',
  toAccount:'به حساب',
  totalAssets:'تعداد دارایی‌ها',
  totalBookValue:'ارزش دفتری کل',
  bookValue:'ارزش دفتری',
  depreciationMethod:'روش استهلاک',
  salvageValue:'ارزش اسقاط',
  usefulLife:'عمر مفید (سال)',
  accumulatedDepreciation:'استهلاک انباشته',
  underMaintenance:'تعمیر',
  disposed:'واگذار شده',
  auditSubtitle:'تمام عملیات کاربران به‌صورت خودکار ثبت می‌شود',
  logout:'خروج',

  // Journals
  journalEntries:'دفتر روزنامه',
  newJournal:'سند جدید',
  noJournals:'سندی یافت نشد',
  lineDescription:'شرح ردیف',
  journalNumber:'شماره سند',
  cancelled:'لغو شده',
  isBalanced:'متوازن',
  unbalanced:'نامتوازن',

  // NewSale
  prepayment:'پیش‌پرداخت',
  paymentExceeds:'پرداخت بیشتر از مبلغ کل نیست مجاز',
  productNotFound:'محصول با این بارکد یافت نشد',
  registered:'ثبت شد',
  manageBranches:'مدیریت شعبات',
  phSearchCustomer:'اسم مشتری، شماره تماس ...',
  phSearchProduct:'نام محصول، برند یا دسته‌بندی...',
  items:'آیتم',
  emptyCart:'سبد خرید خالی است',
  amount:'مبلغی',
  percent:'درصدی',

  // ProductDetail
  salesHistory:'تاریخچه فروش',
  purchaseHistory:'تاریخچه خرید',
  profitPerUnit:'سود هر واحد',
  inStock:'موجود',

  // Products
  phSearchProducts:'جستجو: نام، کد یا بارکد...',
  toggleStatus:'فعال/غیرفعال',
  unitPcs:'عدد',
  unitEach:'دانه',
  unitPack:'بسته',
  unitPacket:'پاکت',
  unitBox:'جعبه',
  unitBranch:'شاخه',
  unitCarton:'کارتن',
  unitSheet:'تخته',
  unitKg:'کیلوگرم',
  unitGram:'گرام',
  unitLiter:'لیتر',
  unitMeter:'متر',
  unitSet:'سیت',
  phMinStock:'مثال: 5',

  // PurchaseDetail
  purchaseDocument:'سند خرید',
  supplierInfo:'اطلاعات سپلایر',
  documentNumber:'شماره سند',
  createdAt:'تاریخ ثبت',
  purchaseType:'نوع خرید',
  registerPayment:'ثبت پرداخت',
  paymentHistory:'تاریخچه پرداخت‌ها',
  noSupplier:'بدون سپلایر',
  paymentProgress:'پیشرفت پرداخت',
  unsettledDocument:'سند تسویه نشده',
  paySupplier:'پرداخت به سپلایر',
  enterAmount:'مبلغ پرداختی را وارد کنید...',
  exceedsRemaining:'بیشتر از مانده',
  payHalf:'نصف مبلغ',
  optionalNotes:'توضیحات (اختیاری)...',

  // Purchases
  purchasesList:'لیست خریدها',
  thisMonthPurchases:'خرید این ماه',
  supplierDebt:'بدهی به سپلایرها',
  purchaseCount:'تعداد خرید',
  purchasesAmount:'مبلغ خریدها',
  salesCount:'تعداد فروش',
  month:'ماه',
  autoFiscalYearNote:'همه‌چیز خودکار از روی تاریخ اسناد محاسبه می‌شود',
  phSearchPurchase:'شماره یا سپلایر...',
  phSearchSupplier:'جستجوی نام یا تلفن سپلایر...',
  selectAtLeastOneProduct:'حداقل یک محصول انتخاب کنید',
  enterPrepayment:'مبلغ پرداخت اولیه را وارد کنید...',
  purchase:'خرید',
  transactionsList:'لیست کامل پرداخت‌شده‌ها و باقی‌ها',
  details:'جزئیات',
  purchaseDate: 'تاریخ خرید',
  product: 'محصول',
  grandTotal: 'مجموع',
  purchasesTab: 'خرید ها',
  newPurchase: 'خرید جدید',

  // Revenues
  newRevenue:'درآمد جدید',
  noRevenues:'درآمدی یافت نشد',
  revenueTitle:'نام / عنوان درآمد',
  phRevenueTitle:'مثال: فروش کالای ماه حمل، اجاره مغازه...',
  receiptMethod:'روش دریافت',
  referenceNumber:'شماره مرجع / چک',

  // Reports
  reportCenter:'مرکز گزارش‌ها',
  salesReport:'گزارش فروشات',
  purchasesReport:'گزارش خریدها',
  customersReport:'گزارش مشتریان',
  suppliersReport:'گزارش سپلایرها',
  invoiceCount:'تعداد فاکتور',
  dailyPurchasesChart:'نمودار خریدهای روزانه',
  customersList:'لیست مشتریان',
  debtorCustomers:'مشتری بدهکار',
  suppliersList:'لیست سپلایرها',
  suppliersWithDebt:'با بدهی',
  totalSuppliers:'مجموع سپلایرها',
  productsList:'لیست محصولات',
  expensesList:'لیست مصارف',
  totalProducts: 'مجموع محصول',
  cashboxTransactions:'تراکنش‌های صندوق',
  printDate:'تاریخ چاپ',
  other:'سایر',


  //others

  netLoss: 'ضرر خالص',
  noExpenses: 'مصارفی نیست',
  sellValue: 'ارزش فروش',

  // SaleDetail
  customerInfo:'اطلاعات مشتری',
  invoiceInfo:'اطلاعات فاکتور',
  invoiceNumber:'شماره فاکتور',
  saleDate:'تاریخ فروش',
  saleType:'نوع فروش',
  unitPrice:'قیمت واحد',
  tax:'مالیات',
  paymentProgress:'پیشرفت پرداخت',
  unsettledInvoice:'فاکتور تسویه نشده',
  paymentNotesPlaceholder:'توضیح پرداخت...',

  // Sales
  salesList:'لیست فروشات',
  currentCredit:'نسیه جاری',
  printInvoice:'چاپ فاکتور',
  sale:'فروش',

  // SupplierProfile
  paymentRegistered:'پرداخت ثبت شد',
  paymentForPurchase:'پرداخت',
  overduePurchases:'خریدهای معوق',
  payFullDebt:'پرداخت کل بدهی',

  // Suppliers
  totalSuppliers:'مجموع سپلایرها',
  activeSuppliers:'سپلایر فعال',
  profile:'پروفایل',
  phTaxId:'شناسه مالیاتی...',

  // Branches & Users
  branchManagement:'مدیریت شعبات',
  branches:'شعبات',
  newBranch:'شعبه جدید',
  branchName:'نام شعبه',
  branchCode:'کود شعبه',
  mainBranch:'شعبه مرکزی',
  totalBranches:'کل شعبات',
  activeBranches:'شعبه فعال',
  inactiveBranches:'شعبه غیرفعال',
  noBranches:'شعبه‌ای یافت نشد',
  editBranch:'ویرایش شعبه',
  phBranchName:'مثال: شعبه کابل',
  phBranchCode:'مثال: KBL',
  managerName:'مسئول شعبه',
  phManagerName:'نام مسئول',
  isMainBranch:'شعبه مرکزی',
  deleteBranch:'حذف شعبه',
  deleteBranchConfirm:'آیا مطمئن هستید؟ شعبه',
  deactivate:'غیرفعال کن',
  activate:'فعال کن',
  userManagement:'مدیریت کاربران',
  users:'کاربران',
  addUser:'کاربر جدید',
  editUser:'ویرایش کاربر',
  fullName:'نام کامل',
  password:'رمز عبور',
  changePassword:'تغییر رمز عبور',
  newPassword:'رمز عبور جدید',
  passwordChanged:'رمز عبور با موفقیت تغییر کرد',
  minLengthPassword:'حداقل ۶ کاراکتر',
  lastLogin:'آخرین ورود',
  branchAccess:'دسترسی به شعبات',
  phSearchUser:'نام یا ایمیل...',
  deletedByAdmin:'حذف توسط ادمین',
  companyName: 'شرکت من',
  loginSubtitle: 'ورود به داشبورد',
  login: 'ورود',


  // Partners
investmentDeposit:'سرمایه‌گذاری / واریز',
capitalIncrease:'افزایش سرمایه',
capitalDecrease:'کاهش سرمایه',
partnerWithdrawal:'برداشت شریک',
transferToPartner:'انتقال به شریک دیگر',
profitDistributed:'سود توزیع شد',
monthNetProfit:'سود خالص ماه',
totalShare:'مجموع سهم',
remainingShare:'باقی سهم',
noPartners:'شریکی ثبت نشده',
noPartnersFound:'شریکی یافت نشد',
phSearchPartner:'نام، کود، تلفن...',
phSharePercent:'مثال: 33.33',
phInitialCapital:'مثال: 100000',
partnerAddress:'آدرس شریک',
saveTransaction:'ثبت تراکنش',
profitAmount:'مبلغ سود برای توزیع',
phProfitAmount:'مبلغ سود قابل توزیع را وارد کنید...',
phProfitDesc:'شرح توزیع سود...',
distributionPreview:'پیش‌نمایش توزیع',
manualDistribution:'تقسیم دستی سود بین شرکا',
suggestByPercent:'پیشنهاد بر اساس درصد',
fullyAllocated:'تمام سود تقسیم شد',
remainingToAllocate:'باقی‌مانده برای تقسیم',
shareChangeHistory:'تاریخچه تغییر سهم',
shareChanges:'تغییر سهم',
partnerReport:'گزارش شرکا',
filterTransactionType:'فیلتر نوع تراکنش',
allTransactions:'همه تراکنش‌ها',
change:'تغییر',
partnerName:'نام شریک',
noChanges:'تغییری ثبت نشده',
transferReceived:'انتقال دریافتی',
transferPaid:'انتقال پرداختی',
profit:'سود',
phTransactionDesc:'شرح تراکنش را بنویسید...',
toPartner:'شریک مقصد',
partnersCapitalReport:'گزارش سرمایه شرکا',

};

export default da;